import { Component, Input } from '@angular/core';
import { AuthService } from '../../../auth/services/auth.service';
import { NavService } from '../../services/nav.service';

@Component({
  selector: 'mpro-panel-dropdown',
  templateUrl: './panel-dropdown.component.html',
  styleUrls: ['./panel-dropdown.component.scss']
})
export class PanelDropdownComponent {
  @Input() name: string
  @Input() jobTitle: string

  public isProfileMenuOpened: boolean = false;

  constructor(public authService: AuthService, public navService: NavService) { }

  public closeWhenClickedOutside(event: Event) {
    this.isProfileMenuOpened = false;
  }

  public toggleProfileMenu(): void {
    this.isProfileMenuOpened = !this.isProfileMenuOpened;
  }
}
